<template>
  <el-form
    label-width="140px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="用户名ID" required>
      <el-input v-model="form.id" disabled clearable />
    </el-form-item>
    <el-form-item label="用户名" required>
      <el-input v-model="form.username" disabled clearable />
    </el-form-item>
    <el-form-item label="累计充值额度" required>
      <el-input v-model="form.recharge_money" clearable />
    </el-form-item>
    <el-form-item label="累计充值次数" required>
      <el-input v-model="form.recharge_num" clearable />
    </el-form-item>
    <el-form-item label="累计提款额度" required>
      <el-input v-model="form.withdraw_money" clearable />
    </el-form-item>
    <el-form-item label="累计提款次数" required>
      <el-input v-model="form.withdraw_num" clearable />
    </el-form-item>
    <el-form-item label="用户签到额度" required>
      <el-input v-model="form.signin_money" clearable />
    </el-form-item>
    <el-form-item label="用户签到次数" required>
      <el-input v-model="form.signin_num" clearable />
    </el-form-item>
    <el-form-item label="用户抽奖收益" required>
      <el-input v-model="form.raffle_money" clearable />
    </el-form-item>
    <el-form-item label="用户抽奖次数" required>
      <el-input v-model="form.raffle_num" clearable />
    </el-form-item>
    <el-form-item label="会员等级" required>
      <el-input v-model="form.memberLevel" clearable />
    </el-form-item>
    <el-form-item label="团队长等级" required>
      <el-input v-model="form.teamLevel" clearable />
    </el-form-item>
    <!-- <el-form-item label="团队作业金额" required>
      <el-input v-model="form.team_invite" clearable />
    </el-form-item>
    <el-form-item label="团队投资v1金额" required>
      <el-input v-model="form.team_invite_v1" clearable />
    </el-form-item>
    <el-form-item label="团队投资v2金额" required>
      <el-input v-model="form.team_invite_v2" clearable />
    </el-form-item>
    <el-form-item label="团队返利次数" required>
      <el-input v-model="form.team_invite_num" clearable />
    </el-form-item>
    <el-form-item label="团队人数" required>
      <el-input v-model="form.team_invite_user" clearable />
    </el-form-item>
    <el-form-item label="团队充值金额" required>
      <el-input v-model="form.team_recharge" clearable />
    </el-form-item>
    <el-form-item label="团队充值金额v1" required>
      <el-input v-model="form.team_recharge_v1" clearable />
    </el-form-item>
    <el-form-item label="团队充值金额v2" required>
      <el-input v-model="form.team_recharge_v2" clearable />
    </el-form-item> -->
    <el-form-item label="用户总收益" required>
      <el-input v-model="form.income_money" clearable />
    </el-form-item>
    <el-form-item label="用户投资额度" required>
      <el-input v-model="form.invest_money" clearable />
    </el-form-item>
    <el-form-item label="用户总订阅数量" required>
      <el-input v-model="form.invest_num" clearable />
    </el-form-item>
   
  </el-form>
</template>

<script setup>
import { getCurrentInstance, nextTick, onMounted, ref } from "vue";


const form = ref({
  id: "",
  username: "",
  recharge_money: "",
  recharge_num: "",
  withdraw_money: "",
  withdraw_num: "",
  signin_money: "",
  signin_num: "",
  raffle_money: "",
  raffle_num: "",
  // team_invite: "",
  // team_invite_v1: "",
  // team_invite_v2: "",
  // team_invite_num: "",
  // team_invite_user: "",
  // team_recharge: "",
  // team_recharge_v1: "",
  // team_recharge_v2: "",
  income_money: "",
  invest_money: "",
  invest_num: "",
  memberLevel: '',
  teamLevel: '',
});
const props = defineProps(["item"]);

onMounted(() => {
  nextTick(() => {
    form.value = Object.assign(form.value, props.item);
    getUserState();
  });
});


const { proxy } = getCurrentInstance();
const getUserState = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "user/getUserInfos?id=" + form.value.id,
  });

  if (res.code == 0) {
    form.value = Object.assign(form.value, res.data);
  }
};


defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}
.demo-form-inline .el-input {
  --el-input-width: 260px;
}

.demo-form-inline .el-select {
  --el-select-width: 260px;
}
/deep/ .el-radio-group {
  width: 220px;
}
.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}
/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
